import React, { useState } from "react";
import { MenuItem, Select, FormControl, InputLabel, FormControlLabel, Checkbox, SelectChangeEvent } from "@mui/material";
import { useMutation, gql } from "@apollo/client";
import { setListWaitTime, setListWaitTimeVariables } from "types/gql-types";

const SET_WAIT_TIME_MUTATION = gql`
  mutation setListWaitTime($id: ID!, $waitTime: String!) {
    setListWaitTime(id: $id, waitTime: $waitTime) {
      id,
      waitTime
    }
  }
`;

type WaitTimeSelectProps = {
  interestListId: string;
  label: string;
  initialValue?: string;
}
const defaultValue = "MULTI_YEAR_WAITLIST";

const WaitTimeSelect: React.FC<WaitTimeSelectProps> =
({ interestListId, label, initialValue = defaultValue }) => {
  const [waitTime, setWaitTime] = useState(initialValue);
  const [isMultiYearWait, setIsMultiYearWait] = useState(defaultValue === initialValue);
  const [sendWaitTime, { loading, error }] =
  useMutation<setListWaitTime, setListWaitTimeVariables>(SET_WAIT_TIME_MUTATION);
  const updateWaitTime = (value: string) => {
    setWaitTime(value);

    sendWaitTime({ variables: { waitTime: value, id: interestListId } });
  };

  const handleSelectChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    updateWaitTime(value);
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsMultiYearWait(event.target.checked);
    updateWaitTime(event.target.checked ? defaultValue : "");
  };

  if (error) return <p>An error occurred</p>;

  return (
    <>
      <FormControl fullWidth variant="outlined" disabled={isMultiYearWait || loading}>
        <InputLabel>{label}</InputLabel>
        <Select value={waitTime} label={label} onChange={handleSelectChange}>
          <MenuItem value="HALF_YEAR_WAITLIST">Under 6 months</MenuItem>
          <MenuItem value="UNDER_YEAR_WAITLIST">Under 1 year</MenuItem>
          <MenuItem value="UNDER_TWO_YEARS_WAITLIST">1-2 years</MenuItem>
          <MenuItem value="UNDER_THREE_YEARS_WAITLIST">2-3 years</MenuItem>
          <MenuItem value="UNDER_FIVE_YEARS_WAITLIST">4-5 years</MenuItem>
          <MenuItem value="OVER_FIVE_YEARS_WAITLIST">5+ years</MenuItem>
          <MenuItem value="OVER_DECADE_WAITLIST">10+ years</MenuItem>
          <MenuItem value={defaultValue} disabled>Multi-year wait</MenuItem>
        </Select>
      </FormControl>
      <FormControl disabled={loading}>
        <FormControlLabel
          control={<Checkbox checked={isMultiYearWait} onChange={handleCheckboxChange} />}
          label="Multi-year wait"
        />
      </FormControl>
    </>
  );
};

export default WaitTimeSelect;
